import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IClient } from '@interfaces/client.interface';
import { Api } from '@root/core/constants/api-routes.constants.';
import { CONFIG } from '@root/core/constants/app.constants';
import { Utils } from '@root/shared/utils';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  server = CONFIG.API_SERVER;
  api = Api.USERS

  constructor(private httpClient: HttpClient, private utils: Utils) { }


  getAll(): Observable<IClient[]> {
    const url = `${this.server}${this.api}`
    return this.httpClient.get<IClient[]>(url)
  }
  getById(id: number): Observable<IClient[]> {
    const url = `${this.server}${this.api}`
    return this.httpClient.get<IClient[]>(url)
  }
  create(order: IClient): Observable<IClient> {
    const url = `${this.server}${this.api}`
    return this.httpClient.post<IClient>(url, order).pipe(
      //catchError(e =>{this.utils.errorManager(e)})
    )
  }


  update(order: IClient): Observable<IClient> {
    const url = `${this.server}${this.api}`
    return this.httpClient.put<IClient>(url, order)
  }
  delete(id: number): Observable<any> {
    const url = `${this.server}${this.api}`
    return this.httpClient.delete<IClient>(url)
  }
}
